import { CcamCode } from '../core/models/CcamCode'
import { CommonCare } from '../core/models/CommonCare'
import { Simulation } from '../core/models/Simulation'
import { SimulationResult } from '../core/models/SimulationResult'
import { SimulationGatewayInterface } from '../core/SimulationGateway.interface'

export default class SimulationGateway implements SimulationGatewayInterface {
  async fetchCommonCares(): Promise<CommonCare[]> {
    const response = await fetch('/simulations/common_cares')
    const data = await response.json()
    return data
  }
  async fetchCcamCodes(
    categoryLabel: string,
    search?: string
  ): Promise<CcamCode[]> {
    const params = new URLSearchParams()
    params.append('ccam_category_label', categoryLabel)
    params.append('q', search)
    const response = await fetch(`/simulations/ccam_codes?${params}`)
    const data = await response.json()
    return data
  }
  async fetchCcamCategoryLabels(): Promise<string[]> {
    const response = await fetch('/simulations/ccam_category_labels')
    const data = await response.json()
    return data.sort()
  }

  async fetchLexicalCodes(): Promise<Record<string, string[]>> {
    const response = await fetch('/simulations/lexical_codes')
    const data = await response.json()
    return data
  }

  async fetchSimulationResult(
    simulation: Simulation
  ): Promise<SimulationResult> {
    const ssAmount = Math.min(
      simulation.careAmount,
      (simulation.ssRate / 100) * simulation.referenceAmount
    )

    let insuranceAmount = 0

    if (simulation.insuranceUnit === 'brss') {
      insuranceAmount = Math.min(
        simulation.careAmount - ssAmount,
        (simulation.insuranceRate / 100) * simulation.referenceAmount
      )
    } else {
      insuranceAmount = Math.min(
        simulation.careAmount - ssAmount,
        (simulation.insuranceRate / 100) * simulation.referenceAmount - ssAmount
      )
    }

    const meAmount = simulation.careAmount - ssAmount - insuranceAmount

    return {
      careAmount: simulation.careAmount,
      ssAmount: Math.round(ssAmount * 100) / 100,
      insuranceAmount: Math.round(insuranceAmount * 100) / 100,
      meAmount: Math.round(meAmount * 100) / 100,
    }
  }

  async fetchCcamCodeUpdateImportDate(): Promise<Record<string, string>> {
    const response = await fetch('/simulations/last_ccam_code_update_import_date')
    const data = await response.json()
    return data
  }
}
